import { useGetOne } from "react-admin";

const metaCustomer = {
  sparseFields: ["id", "shortUserId", "firstName", "lastName"],
};

const CustomerNameField = ({ clientId }) => {
  const { data: customer } = useGetOne("Customer", {
    id: clientId,
    meta: metaCustomer,
  });

  return customer ? `${customer.firstName} ${customer.lastName}` : "-";
};

export default CustomerNameField;
